// Reducer for Scribe
import {
  SET_SCRIBE_ACTIVE,
  SET_SCRIBE_ACTIVE_SUCCESS,
  SET_SCRIBE_ACTIVE_FAILURE,
  SHOW_HELP_ICONS,
  SHOW_HELP_ICONS_SUCCESS,
  SHOW_HELP_ICONS_FAILURE,
} from "./actionType";

const initState = {
  scribeActive: false,
  scribeActiveLoading: false,
  scribeActiveError: null,
  showHelpIcons: false,
};

const Scribe = (state = initState, action) => {
  switch (action.type) {
    case SET_SCRIBE_ACTIVE:
      return {
        ...state,
        scribeActiveLoading: true,
      };
    case SET_SCRIBE_ACTIVE_SUCCESS:
      return {
        ...state,
        scribeActiveLoading: false,
        scribeActive: action.payload,
      };
    case SET_SCRIBE_ACTIVE_FAILURE:
      return {
        ...state,
        scribeActiveLoading: false,
        scribeActiveError: action.payload,
      };
    case SHOW_HELP_ICONS:
      return {
        ...state,
      };
    case SHOW_HELP_ICONS_SUCCESS:
      return {
        ...state,
        showHelpIcons: action.payload,
      };
    case SHOW_HELP_ICONS_FAILURE:
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default Scribe;
